import { IActivatePropertyArgs } from "./util/model";
import useReadOnlyModeGuard from "@rf-hooks/useReadOnlyModeGuard";
const useActivateProperty = () => {
  const { guardReadOnlyAction } = useReadOnlyModeGuard();
  const handleActivateProperty = (arg: IActivatePropertyArgs) => {
    guardReadOnlyAction(arg.title || "reactivar propiedad", "use-activate-property");
  };

  return {
    handleActivateProperty
  };
};

export default useActivateProperty;
